import { PillViewType } from '../../../../components/PillsInput';
import {
  QueryBuilderEntityConfigType,
  QueryBuilderTokenType,
} from '../../../../types';
import { getBracketLabel, getTokenId } from './helpers';

type MapTokensToPillViewsArgsType = {
  tokens: QueryBuilderTokenType[];
  entities: QueryBuilderEntityConfigType[];
  activeTokenIndex: number | null;
};

const findEntity = (
  entities: QueryBuilderEntityConfigType[],
  entityKey: string
): QueryBuilderEntityConfigType | undefined =>
  entities.find((entity) => entity.key === entityKey);

export const mapTokensToPillViews = ({
  tokens,
  entities,
  activeTokenIndex,
}: MapTokensToPillViewsArgsType): PillViewType[] =>
  tokens.map((token, index) => {
    const id = getTokenId(token);

    if (token.type === 'entityValue') {
      const entity = findEntity(entities, token.entityKey);

      return {
        id,
        label: `${entity?.label}: ${token.value}`,
        color: entity?.color,
        isClickable: true,
      };
    }

    if (token.type === 'operator') {
      return {
        id,
        label: token.operator,
        isActive: activeTokenIndex === index,
        isClickable: true,
      };
    }

    if (token.type === 'bracket') {
      return { id, label: getBracketLabel(token.bracket) };
    }

    const entity = findEntity(entities, token.entityKey);

    return {
      id,
      label: `${entity?.label}:`,
      color: entity?.color,
      isActive: activeTokenIndex === index,
    };
  });
